import { WsrvImage } from "@organic-return/foundation-react/src/components/Media"
import { EWsrvTransform } from "@organic-return/foundation-react/src/lib"
import { graphql, useStaticQuery } from "gatsby"
import React from "react"

const TestimonialList = () => {
    const data = useStaticQuery(graphql`
    query {
        allDrupalTestimonial(sort: {sortOrder: ASC}) {
          nodes {
            text
            attribution
            image {
              url
            }            
          }
        }
    }
  `)

    const testimonials = data.allDrupalTestimonial?.nodes ?? []

    const containImage = testimonials.some((t: any) => t.image?.url)
    
    return (
        <>
            {!containImage && <section className="testimonial-list relative mx-auto w-full max-w-screen-xl flex flex-col divide-y px-5">
                {testimonials?.[0] && testimonials.map((testimonial: any) => (
                    <div className="w-full flex flex-col py-8">
                        <div className="block textimonial-text" dangerouslySetInnerHTML={{ __html: testimonial.text }}></div>
                        {testimonial.attribution && <div className="inline testimonial-attribution italic" dangerouslySetInnerHTML={{ __html: testimonial.attribution }}></div>}
                    </div>
                ))}
            </section>}
            {containImage && <section className="testimonial-list relative mx-auto w-full max-w-screen-xl flex flex-col px-5 py-10 gap-y-10">
                {testimonials?.[0] && testimonials.map((testimonial: any) => (
                    <div className="w-full flex flex-wrap md:flex-nowrap gap-10">
                        <div className="w-full md:w-1/2 lg:w-1/4">
                            {testimonial.image?.url && 
                                <WsrvImage 
                                    urlParams={{
                                        originURL: testimonial.image.url,
                                        preset: EWsrvTransform.fit3x2,                                                                              
                                    }}
                                    imgProps={{
                                        style: {
                                            width: 250,
                                            height: 167
                                        }
                                    }}
                                />
                            }
                        </div>
                        <div className="w-full md:w-1/2 lg:w-3/4 flex flex-col">
                            {testimonial.attribution && <h3 className="mb-2">{testimonial.attribution}</h3>}
                            <div className="block textimonial-text" dangerouslySetInnerHTML={{ __html: testimonial.text }}></div>
                        </div>
                    </div>
                ))}
            </section>}
        </>
    )
}

export default TestimonialList
export const query = graphql`
fragment DrupalTestimonialListContent on DrupalTestimonialList {
    id  
}
`